// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"303":"4d1708d3ffda0f16","525":"32cc393837843526","552":"d372611d889441c5"}[chunkId] + ".js";
};